import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchMedia, resetMedia} from "../../../../creators/media";

import MediaViewer from '../../MediaViewer';
import Avatar from '../../Avatar';
import DateSince from '../../Date';
import OneThumbTimeline from "./OneThumbTimeline";
import Views from "../../Views";
import Answers from "../../Answers";
import ThumbTimeline from "./ThumbTimeline";
import Icon from "../../Icon";
import Modal from "../../Modal";
import createLink from "../../../../libs/createLink";
import Like from "../../Like/Like";
import {isNoFollowAlbum, isNoFollowProfil} from "../../../../libs/helper";


class MosaicStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
        };
        // this.fetchMedia = this.fetchMedia.bind(this);

        // this.fetchMedia(this.props.parentId);
    }

    // componentWillUnmount() {
    //     this.props.resetMedia();
    // }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.parentId !== this.props.parentId) {
    //         this.fetchMedia(this.props.parentId);
    //     }
    // }

    // shouldComponentUpdate(nextProps) {
    //     return nextProps.mediaInitialized !== this.props.mediaInitialized;
    // }

    // fetchMedia(id) {
    //     this.props.fetchMedia(id);
    // }

    render() {
        let isOneMedia = true;
        let isCreateAlbum = false;
        let hasOwner = this.props.parentId.owner !== null && this.props.parentId.owner._id;
        let relLinkAlbum = isNoFollowAlbum(this.props) ? { rel: "nofollow" } : {};
        let relLinkProfil = isNoFollowProfil(this.props.parentId.owner) ? { rel: "nofollow" } : {};
        return (
            <div className="card media-card">
                        <div className="wrapper">
                            {hasOwner ? (
                                <Link to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>
                                    <Avatar avatar={this.props.parentId.owner && this.props.parentId.owner.profile.avatar}
                                            gender={this.props.parentId.owner ? this.props.parentId.owner.profile.gender : "guest"}
                                            alt=""/>
                                </Link>
                            ) : (
                                <Avatar gender={"guest"}/>
                            )}
                            <div className="column">
                                <div className="username row wrap">
                                    {hasOwner ? (
                                        <Link to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>
                                            {this.props.parentId.owner.username}
                                        </Link>
                                    ) : (
                                        <span>this.props.authorName</span>
                                    )}&nbsp;
                                    {isCreateAlbum ? "a créé l'album" : "a ajouté du contenu à l'album"}
                                    &nbsp; {this.props.parentId.owner && this.props.parentId.album && (<Link
                                    to={createLink("userAlbum", {
                                        ...this.props.parentId.owner, album : this.props.parentId.album
                                    })} {...relLinkAlbum}>{this.props.parentId && this.props.parentId.album.title}
                                </Link>)}
                                </div>
                                <DateSince
                                    date={this.props.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                />
                            </div>
                        </div>
                        {isOneMedia ? (
                            <Fragment>
                                <div className="mosaic-status media">
                                    <div className="wrapper-mosaic">
                                        <Modal toggle={this.state.toggle}
                                               handleClose={() => this.setState({toggle: false})}>
                                            <MediaViewer mediaId={this.props.parentId._id} mediaSlug={this.props.parentId.slug} handleClose={() => this.setState({toggle: false})} />
                                        </Modal>
                                        <OneThumbTimeline
                                            {...this.props.parentId}
                                            isVideoThumb={this.props.parentId.kind === "video"}/>
                                    </div>
                                </div>
                                <div className="footer">
                                    <Views type="icon"
                                           value={this.props.parentId && (this.props.parentId.count.view || 0)}/>
                                    <Answers value={this.props.parentId && this.props.parentId.count.comment}/>
                                    {this.props.parentId && this.props.parentId._id &&
                                        <Like
                                            isLiked={this.props.parentId.isLiked}
                                            value={this.props.parentId && (this.props.parentId.count.like || 0)}
                                            likeType={"medias"}
                                            parentId={this.props.parentId._id}
                                        />
                                    }
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <div className="mosaic-status medias">
                                    <div className="wrapper-mosaic">
                                        {this.props.parentId.length >= 2 && this.props.parentId.length < 3 ? (
                                            <div className={"two-thumb-medias"}>
                                                {this.props.parentId && this.props.parentId.map((item, index) => (
                                                    <ThumbTimeline
                                                        {...item}
                                                        key={index}
                                                        isVideoThumb={item.type === "video"}/>
                                                ))}
                                            </div>
                                        ) : this.props.parentId.length >= 2 && this.props.parentId.length <= 3 ? (
                                            <div className={"three-thumb-medias"}>
                                                <div className={"media-container"}>
                                                    {Array.isArray(this.props.media) && this.props.media.slice(0, 1).map((item, index) => (
                                                        <ThumbTimeline
                                                            {...item}
                                                            key={index}
                                                            isVideoThumb={item.type === "video"}/>
                                                    ))}
                                                </div>
                                                <div className={"media-container"}>
                                                    {Array.isArray(this.props.media) && this.props.media.slice(1, 3).map((item, index) => (
                                                        <ThumbTimeline
                                                            {...item}
                                                            key={index}
                                                            isVideoThumb={item.type === "video"}/>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : this.props.media.length >= 3 && this.props.media.length <= 4 ? (
                                            <div className={"four-thumb-medias"}>
                                                {this.props.media.map((item, index) => (
                                                    <ThumbTimeline
                                                        {...item}
                                                        key={index}
                                                        isVideoThumb={item.type === "video"}/>
                                                ))}
                                            </div>
                                        ) : this.props.media.length >= 4 && this.props.media.length <= 5 ? (
                                            <div className={"five-thumb-medias"}>
                                                {this.props.media.map((item, index) => (
                                                    <ThumbTimeline
                                                        {...item}
                                                        key={index}
                                                        isVideoThumb={item.type === "video"}/>
                                                ))}
                                            </div>
                                        ) : this.props.media.length > 5 && (
                                            <div className={"more-thumb-medias"}>
                                                {this.props.media.slice(0, 4).map((item, index) => (
                                                    <ThumbTimeline
                                                        {...item}
                                                        key={index}
                                                        isVideoThumb={item.type === "video"}/>
                                                ))}
                                                {this.props.media.slice(5, 6).map((item, index) => (
                                                    <Link key={index}
                                                          to={`user/${this.props.owner._id}-${this.props.owner.slug}/album/${this.props.media && this.props.media.album._id}-${this.props.media && this.props.media.album.slug}`}
                                                          className={"thumb-timeline see-album"}
                                                          {...relLinkAlbum}
                                                    >
                                                        <div className={"thumb-wrapper loaded"}
                                                             style={{backgroundImage: `url(${item.filename.urlThumb || item.filename.url})`}}>
                                                            <div className={"black-layer"}></div>
                                                            <Icon type={"plus"}/>
                                                        </div>
                                                    </Link>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Fragment>
                        )}
                        {/*{isOneMedia && (*/}
                        {/*<Comments*/}
                        {/*{...this.props}*/}
                        {/*mediaId={this.props.typeId[0]}*/}
                        {/*mediaType={this.props.type || 'gallery'}*/}
                        {/*typeId={this.props.parentTypeId || 0}*/}
                        {/*mediaComment={this.props.comment}*/}
                        {/*isMore={true}*/}
                        {/*limit={2}*/}
                        {/*nextLimit={5}*/}
                        {/*/>*/}
                        {/*)}*/}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        media: state.media.data,
        mediaLoading: state.media.loading,
        mediaInitialized: state.media.initialized,
        mediaTotal: state.media.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMedia,
    resetMedia
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MosaicStatus);
